import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "options", "size", "value"];
import { Controllable } from '../Controllable';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import partial from 'react-utils/partial';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { Button } from '../Button/Button';
import { Tooltip } from '../Tooltip/Tooltip';
import { ButtonGroup } from '../ButtonGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewControllerComponent = _ref => {
  let {
      onChange: __onChange,
      options,
      size = 'small',
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleChange = (newValue, evt) => {
    if (newValue === value) {
      return;
    }
    if (__onChange) {
      __onChange(syntheticEvent(newValue, evt));
    }
  };
  return /*#__PURE__*/_jsx(ButtonGroup, Object.assign({}, rest, {
    role: "radiogroup",
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'ViewController',
    children: options.map(option => {
      const isActive = option.value === value;
      const {
        'data-test-id': dataTestId
      } = option;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: option.title,
        children: /*#__PURE__*/_jsx(Button, {
          active: isActive,
          "aria-checked": isActive,
          "data-test-id": dataTestId,
          disabled: option.disabled,
          onClick: partial(handleChange, option.value),
          responsive: false,
          role: "radio",
          size: size,
          use: "view-group",
          children: option.buttonText || option.text || option.value
        })
      }, option.value);
    })
  }));
};
export const ViewController = Controllable(ViewControllerComponent);
ViewController.displayName = 'ViewController';